import { lang } from '../../assets/lang'
const instagram_bot_addon = !! window.xitFlowBuilderData.instagram_addon

const defaultSelectOptions = [
  { key: 'Text', value: lang.user_input_flow_single_html_reply_type_text },
  { key: 'Email', value: lang.user_input_flow_single_html_reply_type_email },
  { key: 'Phone', value: lang.user_input_flow_single_html_reply_type_phone },
  { key: 'Number', value: lang.user_input_flow_single_html_reply_type_number },
  { key: 'URL', value: lang.user_input_flow_single_html_reply_type_url },
  { key: 'File', value: lang.user_input_flow_single_html_reply_type_file },
  { key: 'Image', value: lang.user_input_flow_single_html_reply_type_image },
  { key: 'Video', value: lang.user_input_flow_single_html_reply_type_video },
]

const instagramBotSelectOptions = [
  { key: 'Date', value: lang.user_input_flow_single_html_reply_type_date },
  { key: 'Time', value: lang.user_input_flow_single_html_reply_type_time },
  { key: 'Datetime', value: lang.user_input_flow_single_html_reply_type_datetime },
]

const userInputFlowSingleSelectOptions = instagram_bot_addon
  ? defaultSelectOptions
  : [...defaultSelectOptions, ...instagramBotSelectOptions]

export {
  userInputFlowSingleSelectOptions,
}